<template>
  <div class="main">
    
    <Modal v-if="$store.state.showLoginModal" ref="loginModal" @close="$store.state.showLoginModal = false">
        <template #modal-content-left>
          
          <h1 class="modal-title">Join ThreadOk 👋</h1>
    
          <div class="modal-text">
            <p>🧵 <b>Submit and find</b> Twitter threads</p>
            <p>🔎 Add <b>unlimited filters</b></p>
            <p>🔥 <b>Upvote</b> for the best Twitter threads</p>
            <p>🚦 <b>Drive traffic</b> to your Twitter threads</p>
          </div>
        
        </template>
        <template #modal-content-right><Register @registered="$store.state.showLoginModal = false"/></template>
    </Modal>

    <Header/>
    <Loading v-if="$store.state.showLoading" ref="loading"/>
    <router-view/>
    <button v-if="deferredPrompt" id="pwa" class="primary-button install-button">Install App</button>
    <Footer/>
  </div>
</template>

<script>
import Footer from "@/components/Footer"
import Header from "@/components/Header"
import Modal from "@/components/Modal"
import Loading from "@/components/Loading"
import Register from "@/components/Register"

import firebase from "@/firebase"

export default {
  components: {
    Header,
    Footer,
    Modal,
    Loading,
    Register,
  },

  data() {
    return {
      deferredPrompt: null,
    }
  },

  mounted() {
    // PWA - Documentation
    // https://www.simicart.com/blog/pwa-add-to-home-screen/
    window.addEventListener('beforeinstallprompt', (e) => {
      this.deferredPrompt = e
    })
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
      const installButton = document.getElementById('pwa')
      installButton.style.display = 'block'
      installButton.addEventListener('click', () => {
        installButton.style.display = 'none'
        this.deferredPrompt.prompt()
        this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              firebase.analytics.logEvent('pwa-install-accepted')
            } else {
              firebase.analytics.logEvent('pwa-install-rejected')
            }
            this.deferredPrompt = null
          })
      })
    })
  },

  methods: {
    
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap');
@import './assets/styles/common.css';

body{
  padding: 0rem;
  margin: 0rem;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  background-color: var(--global-background-color);
}
button{
  font-family: 'Open Sans', sans-serif;  
  font-size: 14px;
  color: var(--secondary-text-color);
}
input{
  font-family: 'Open Sans', sans-serif;  
  font-size: 14px;
}
input:hover{
  background-color: var(--secondary-color);
}
textarea{
  font-family: 'Open Sans', sans-serif;  
  font-size: 14px;
}
textarea:hover{
  background-color: var(--secondary-color);
}
textarea:focus{
  outline: none;
}
a{
  color: var(--secondary-color);
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}
p, h1, h2, h3, h4, ul, li{
  color: var(--secondary-text-color);
}

@media (max-width: 760px){
  input{
    font-size: 12px;
  }
  button{
    font-size: 12px;
  }
  body{
    font-size: 12px;
  }
}
</style>
